import * as i0 from '@angular/core';
import { Injectable, Directive, Input, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

class SiLocalizationService {
}
SiLocalizationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SiLocalizationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationService, decorators: [{
            type: Injectable
        }] });

class SiLocalizeAttributeDirective {
    constructor(localizationService, renderer2, elementRef) {
        this.localizationService = localizationService;
        this.renderer2 = renderer2;
        this.elementRef = elementRef;
        this.destroyer = new Subject();
    }
    ngOnChanges(changes) {
        if (changes.siLocalizeAttribute.previousValue) {
            Object.keys(changes.siLocalizeAttribute.previousValue)
                .forEach(attribute => this.renderer2.removeAttribute(this.elementRef.nativeElement, attribute));
        }
        this.destroyer.next();
        Object.entries(this.siLocalizeAttribute).forEach(([attribute, value]) => {
            let key;
            let params;
            if (typeof value === 'string') {
                key = value;
                params = undefined;
            }
            else {
                key = value.key;
                params = value.params;
            }
            const translation = this.localizationService.translate(key, params);
            if (typeof translation === 'string') {
                this.updateContent(attribute, translation);
            }
            else {
                translation.pipe(takeUntil(this.destroyer)).subscribe(translationUpdate => this.updateContent(attribute, translationUpdate));
            }
        });
    }
    updateContent(attribute, content) {
        this.renderer2.setAttribute(this.elementRef.nativeElement, attribute, content);
    }
}
SiLocalizeAttributeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizeAttributeDirective, deps: [{ token: SiLocalizationService }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
SiLocalizeAttributeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.4", type: SiLocalizeAttributeDirective, selector: "[siLocalizeAttribute]", inputs: { siLocalizeAttribute: "siLocalizeAttribute" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizeAttributeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siLocalizeAttribute]',
                }]
        }], ctorParameters: function () { return [{ type: SiLocalizationService }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { siLocalizeAttribute: [{
                type: Input
            }] } });

class SiLocalizeDirective {
    constructor(localizationService, renderer2, elementRef) {
        this.localizationService = localizationService;
        this.renderer2 = renderer2;
        this.elementRef = elementRef;
    }
    ngOnChanges() {
        const translation = this.localizationService.translate(this.siLocalize, this.siLocalizeParams);
        if (typeof translation === 'string') {
            this.updateContent(translation);
        }
        else {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            this.subscription = translation.subscribe(value => this.updateContent(value));
        }
    }
    updateContent(content) {
        if (this.content) {
            this.renderer2.removeChild(this.elementRef.nativeElement, this.content);
        }
        this.content = this.renderer2.createText(content);
        this.renderer2.appendChild(this.elementRef.nativeElement, this.content);
    }
}
SiLocalizeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizeDirective, deps: [{ token: SiLocalizationService }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
SiLocalizeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.4", type: SiLocalizeDirective, selector: "[siLocalize]", inputs: { siLocalize: "siLocalize", siLocalizeParams: "siLocalizeParams" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siLocalize]',
                }]
        }], ctorParameters: function () { return [{ type: SiLocalizationService }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { siLocalize: [{
                type: Input
            }], siLocalizeParams: [{
                type: Input
            }] } });

class SiLocalizationModule {
}
SiLocalizationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SiLocalizationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationModule, declarations: [SiLocalizeAttributeDirective, SiLocalizeDirective], exports: [SiLocalizeAttributeDirective, SiLocalizeDirective] });
SiLocalizationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiLocalizeAttributeDirective, SiLocalizeDirective],
                    exports: [SiLocalizeAttributeDirective, SiLocalizeDirective],
                }]
        }] });

/*
 * Public API Surface of siemens-brand-localize
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SiLocalizationModule, SiLocalizationService, SiLocalizeAttributeDirective, SiLocalizeDirective };
